import React, { useEffect, useRef, useState } from 'react';
import { useAddProductContext } from '../../../Contexts/AddProductContext';
import ButtonsIncDec from '../ButtonsIncDec';
import SlotStep from './SlotStep';
import { TbChevronLeft, TbMoodConfuzed, TbPhotoX, TbShare } from 'react-icons/tb';
import Button from '../../Form/Button';
import { useCartContext } from '../../../Contexts/CartContext';
import ButtonOpenStoreCounter from '../ButtonOpenStoreCounter';
import DOMPurify from 'dompurify';
import Img from '../Img';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import CartService from '../../../Services/CartService';
import { useStoreContext } from '../../../Contexts/StoreContext';
import { ImSpinner8 } from 'react-icons/im';
import { PRODUCT_TYPE_COMPOSITE, PRODUCT_TYPE_SIMPLE } from '../../../Utils/Constants/Product';
import ProductPrice from './ProductPrice';
import Badge from '../Badge';
import { HiXMark } from 'react-icons/hi2';
import AddProductObservation from './AddProductObservation';
import Scrollbars from 'react-custom-scrollbars-2';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';
import ButtonAddProduct from './ButtonAddProduct';
import { useProductsHook } from '../../../Hooks/ProductsHook';
import BoxContentEndScrollbars from '../BoxContentEndScrollbars';
import TitleProduct from './TitleProduct';
import { useParams } from 'react-router-dom';
import { useStoreHook } from '../../../Hooks/StoreHook';
import ButtonLink from '../../Form/ButtonLink';
import { useTranslation } from 'react-i18next';
import BoxContentTags from './BoxContentTags';

interface AddProductProps {
    product: any;
    category: any;
    onCancel: CallableFunction;
}

const AddProduct = ({
    product,
    category,
    onCancel = () => {},
}: AddProductProps) => {

const { t } = useTranslation();
const { showAddProduct, setShowAddProduct } = useAddProductContext();
const { addCartTempInConference, setAddProductCartTemp, cartTemp, cartDisplay, currentSteps, setCurrentSteps, requiredStepsValid, allStepsExtrasValid, allStepsIsExtras, disabledButtonAddProduct, setDisabledButtonAddProduct, getPriceTotalSelectedComplements, cartFinished, cartConference, currentCart, loadingCurrentCart, setLoadingCurrentCart, loadingUpdateQuantity, returnToCheckout } = useCartContext();
const { orderType, getOrderTypeIdByName, isStoreCounter, isDelivery } = useOrderTypeContext();
const [height] = useState('45vh');
const [fixedTitle, setFixedTitle] = useState(false);
const fixedTitleRef = useRef<HTMLDivElement | null>(null);
const description = DOMPurify.sanitize(product.description);
const [currentProduct, setCurrentProduct] = useState<any>(product);
const [currentPrice, setCurrentPrice] = useState<number>(0);
const [loadingSteps, setLoadingSteps] = useState(product.type === PRODUCT_TYPE_COMPOSITE);
const { currentStore, cashier } = useStoreContext();
const { getLinkToHome, createGuestToken, getActiveCart } = useStoreHook();
const { company, isMobile, setMainLoading, setMainLoadingIcon, setMainLoadingIconSuccess, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, setEnableLoadProducts } = useLayoutContext();
const scrollRef = useRef<Scrollbars>(null);
const { slug_product} = useParams();

const { sendProducts } = useProductsHook();

const [showShadow, setShowShadow] = useState(false);
const handleScrollFrame = (values: any) => {

    const { scrollTop, scrollHeight, clientHeight } = values;
    // Verifica se o scroll está no início ou no fim para controlar a sombra
    if (scrollTop >= 0 && (scrollTop + clientHeight + 2) < scrollHeight) {
        setShowShadow(true);
    } else {
        setShowShadow(false);
    }

    if (fixedTitleRef.current) {
        const updatePosition = () => {
            if (fixedTitleRef.current) {
                const posFixedTitle = fixedTitleRef.current.getBoundingClientRect();
                setFixedTitle(posFixedTitle.top <= 0);
            }
        };

        updatePosition();
        window.addEventListener("scroll", updatePosition);
        window.addEventListener("resize", updatePosition);

        return () => {
            window.removeEventListener("scroll", updatePosition);
            window.removeEventListener("resize", updatePosition);
        };
    }
}

const isFirstRender = useRef(true);

const autoScrollSteps = (stepIndex: number) => {
    const nextElement = document.getElementById(`step_${stepIndex + 1}`);
    if (!nextElement || !scrollRef.current) return;
    setTimeout(() => { //* only for layout
        nextElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 350);
}

const handleShare = async () => {
    if (navigator.share) {
        try {
            await navigator.share({
                // title: product.name,
                // text: product.name + ' - ' + product.description,
                url: window.location.href,
            });
        } catch (err) {}
    }
};

useEffect(() => {
    //* Exibição da sombra dos itens quando houver scroll
    const boxScroll = document.getElementById('boxScroll_addProduct');
    const scrollContent = document.getElementById('scrollContent_addProduct');

    if (boxScroll && scrollContent) {
        const boxScrollHeight = boxScroll.getBoundingClientRect().height;
        const scrollContentHeight = scrollContent.getBoundingClientRect().height;
        setShowShadow(scrollContentHeight > boxScrollHeight)
    }

    //* Rolagem automática inicial para steps do produto composto
    const initialScrollForCompositeProduct = currentSteps && currentSteps.length > 0 && isFirstRender.current && isMobile && product.type === PRODUCT_TYPE_COMPOSITE;
    if (initialScrollForCompositeProduct) {
        isFirstRender.current = false;
        const scrollEl = (scrollRef.current as any)?.view;
        if (scrollEl) {
            scrollEl.scrollTo({ top: 200, behavior: 'smooth' });
        }
    }

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentSteps])

const handleCancel = () => {
    setShowAddProduct(false)
    setTimeout(() => { //* only for layout
        setCurrentSteps([]);
    }, 250);

    document.title = currentStore.name || company.name;

    if(slug_product) {
        setEnableLoadProducts(false);
    }
    onCancel();
}

const handProductToAdd = () => {
    const categoryId = category?.id ?? currentProduct?.categories?.[0]?.id ?? 1;
    setAddProductCartTemp({...currentProduct, currentCategoryId: categoryId});
}

const handleAdd = () => {

    if(slug_product) {
        setEnableLoadProducts(false);
    }

    if (!isStoreCounter && !currentCart?.cart_id) {
        //* Criando guestToken e cart
        setLoadingCurrentCart(true);
        const orderTypeId = Number(getOrderTypeIdByName(orderType));
        createGuestToken(currentStore.id, orderTypeId)
            .then((resp: any) => {
                const payload = {
                    store_id: currentStore.id,
                    order_type_id: orderTypeId, 
                    order_type: orderType
                }
                getActiveCart(payload)
                    .then(() => handProductToAdd())
                    .catch(() => setLoadingCurrentCart(false));
        })
        .catch(() => setLoadingCurrentCart(false));
    } else {
        handProductToAdd();
    }
}

useEffect(() => {
    if (cartTemp.length > 0) {
            addCartTempInConference();
        if (isStoreCounter) {
            setShowAddProduct(false);
        }
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [cartTemp]);

useEffect(() => {
    if (!isStoreCounter && cartConference.length > 0) {
        cartConference.forEach((item: any) => {
            const payload = {
                order_type: Number(getOrderTypeIdByName(orderType)),
                product_id: item.complementable_id ?? item.id,
                quantity: item.quantity,
                observation: item.observation ?? '',
                ...(isDelivery && {shipping_value: currentStore.shipping_value}),
                ...(item.steps && item.steps.length > 0 && { steps: item.steps })
            }

            sendProducts(currentCart.cart_id, payload)
                .then(() => {
                    if (returnToCheckout) {
                        setMainLoadingIcon(false);
                        setMainLoadingIconSuccess(true);
                        setMainLoadingCloseButton(true);
                        setMainLoadingTitle(t('add_product.redirect_to_checkout.title'));
                        setMainLoadingMessage(t('add_product.redirect_to_checkout.message'));
                        setMainLoading(true);
                    }
                })
                .catch((error) => {});
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [cartConference]);

const handleObservation = (newObservation: string) => {
    setCurrentProduct({...currentProduct, observation: newObservation})
};

useEffect(() => {
    setCurrentProduct({...currentProduct, quantity: 1})
    setCurrentSteps([]);

    return () => {
        setCurrentSteps([]);
    };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

const handleUpdateProduct = (quantity: number) => {
    setCurrentProduct({...currentProduct, quantity: quantity});
}

useEffect(() => {
    const getStepsAndComplements = async () => {
        const payload = {
            store_id: currentStore.id,
            product_id: product.id,
            order_type: Number(getOrderTypeIdByName(orderType)),
        }
        try {
            const cartService = new CartService(orderType);
            const getSteps = await cartService.stepsAndComplements(payload);
            if (getSteps) {
                setCurrentSteps(getSteps.product.product_composite_steps);
            }
        } catch (error: any) {
            setCurrentSteps([]);
        } finally {
            setLoadingSteps(false);
        }
    }

    if (product.type === PRODUCT_TYPE_COMPOSITE && currentSteps?.length === 0) {
        getStepsAndComplements();
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [product.id])

useEffect(() => {

    if (currentSteps) {
        setDisabledButtonAddProduct(
            loadingSteps
                || (product.type === PRODUCT_TYPE_COMPOSITE && !allStepsIsExtras() && !requiredStepsValid())
                || (product.type === PRODUCT_TYPE_COMPOSITE && allStepsIsExtras() && (!allStepsExtrasValid() || !requiredStepsValid()))
                || loadingCurrentCart
                || loadingUpdateQuantity
        );

        if (currentSteps.length > 0) {
            setCurrentPrice(getPriceTotalSelectedComplements())
            setCurrentProduct((prevProduct: any) => ({
                ...prevProduct,
                price: getPriceTotalSelectedComplements()
            }));
        } else {
            setCurrentPrice(product.price)
            setCurrentProduct((prevProduct: any) => ({
                ...prevProduct,
                price: product.price
            }));
        }

    }

// eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentSteps, loadingCurrentCart, loadingUpdateQuantity]);

useEffect(() => {
    if (!showAddProduct) {
        window.history.replaceState(null, '', getLinkToHome());
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [showAddProduct]);

return (
    <section className="flex flex-col justify-between h-full max-h-dvh">

        <div className='relative h-full min-h-24' id="boxScroll_addProduct">
            <Scrollbars
                ref={scrollRef}
                autoHeight={!isMobile}
                autoHide={true}
                autoHeightMin={isMobile ? "100%" : ""}
                autoHeightMax={isMobile ? "100dvh" : "100vh"}
                className='min-h-full overflow-y-auto'
                onScrollFrame={handleScrollFrame}
            >
                <div id='scrollContent_addProduct' className='flex flex-col gap-4 w-full md:h-auto md:max-h-[80vh]' >
                    <div className='flex h-full gap-4'>

                        <div className='h-full md:flex w-full'>
                            <div className={`inline md:flex md:flex-col h-full md:top-0 ${product.type === PRODUCT_TYPE_COMPOSITE ? 'md:self-start md:w-3/6 md:sticky' : 'w-full'}`}>
                                {product.photos?.medium
                                    ?
                                        <div id="boxImage" className="relative md:hidden z-10 sticky top-0 block w-full bg-no-repeat bg-fixed bg-cover bg-center bg-gray-50" style={{height, backgroundImage: `url('${product.photos.medium}')`}}>
                                            <Button outline rounded onClick={() => handleCancel()} className='fixed left-3 top-3 text-white ring-transparent hover:ring-transparent active:ring-transparent bg-gray-900/20 active:brightness-150 hover:constrast-150'>
                                                <div><TbChevronLeft size={25} /></div>
                                            </Button>
                                        </div>
                                    :   <Img src={product.photos?.medium} fallback={
                                            <div className='relative md:hidden flex items-center justify-center w-full h-full bg-gray-100' style={{height}}>
                                                <TbPhotoX size={50} className='text-white' />
                                                <Button rounded onClick={() => handleCancel()} className='fixed left-3 top-3 text-white ring-transparent hover:ring-transparent active:ring-transparent bg-gray-800/10 active:brightness-150 hover:constrast-150'>
                                                    <div><TbChevronLeft size={25} /></div>
                                                </Button>
                                            </div>
                                            } alt={product.name} className="w-full"
                                        />
                                }

                                {/* Title Top (desktop) */}
                                <div className='hidden md:flex md:flex-col md:flex-grow w-full text-left'>
                                    <div className={`flex h-[45vh] max-h-fit justify-center p-2 overflow-hidden ${product.type === PRODUCT_TYPE_COMPOSITE && 'md:pt-4'}`}>

                                        {product.type === PRODUCT_TYPE_COMPOSITE &&
                                            <div className={`
                                                flex items-center w-full justify-center rounded-xl md:m-1
                                                ${product.photos.medium && 'bg-no-repeat bg-cover aspect-square bg-center bg-gray-100 h-64'}
                                            `}>
                                                {product.photos.medium
                                                    ?   <Img src={product.photos?.medium} alt={product.name} className="w-full aspect-square rounded-xl object-cover transition-width ease-in-out duration-200" />
                                                    :   <TbPhotoX size={50} className='text-white' />
                                                }
                                            </div>
                                        }

                                        {product.type === PRODUCT_TYPE_SIMPLE &&
                                            <div className='
                                            flex items-center w-full justify-center md:p-1.5
                                            min-h-[45vh]
                                            rounded md:rounded-xl
                                            bg-no-repeat bg-cover bg-center
                                            bg-gray-50
                                            '
                                            style={{height, backgroundImage: `url('${product.photos.medium}')`}}
                                            >
                                                {!product.photos.medium && <TbPhotoX size={50} className='text-gray-200' />}
                                            </div>
                                        }

                                    </div>

                                    <div className="flex flex-col w-full flex-1 h-auto gap-2 p-4 pb-2 text-left">
                                        <h2 className='text-2xl font-bold text-shopfood-title'>
                                            {product.name}
                                        </h2>

                                        {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                        <BadgeNewProduct product={product} className='flex-inline self-start rounded -mr-0.5' />

                                        {/* PRODUCT SALE  */}
                                        <BadgeProductSale product={product} className='flex-inline self-start rounded -mr-0.5' />

                                        {/* PRICE */}
                                        <div className='font-medium text-nowrap leading-none'>
                                            <ProductPrice product={product} breakLine={false} />
                                        </div>

                                        <div className='flex flex-col gap-4'>
                                            {/* DESCRIPTION */}
                                            <p className='text-sm text-left leading-5 text-gray-500' dangerouslySetInnerHTML={{ __html: description }} />

                                            {/* TAGS */}
                                            <BoxContentTags product={product} />

                                            {/* OBSERVATION */}
                                            {((!isStoreCounter && product.type === PRODUCT_TYPE_SIMPLE) || (isStoreCounter && cartDisplay && product.type === PRODUCT_TYPE_SIMPLE)) &&
                                                <AddProductObservation onHandleObservation={(e: any) => handleObservation(e) } observation={currentProduct.observation} />
                                            }
                                        </div>

                                    </div>
                                </div>

                            </div>


                            <div className={`relative md:w-full bg-white sticky z-20 ${product.type !== PRODUCT_TYPE_COMPOSITE && 'md:hidden'}`}>

                                {product.type === PRODUCT_TYPE_COMPOSITE &&
                                    <div className="absolute z-20 left-0 right-0 -top-8">
                                        <div className="w-10 bg-gray-300 h-[4px] mx-auto rounded-full" />
                                    </div>
                                }

                                <section className='relative md:p-4 md:pl-0 h-full flex flex-col'>

                                    {/* Header/Title Side (mobile) */}
                                    <header className='md:hidden'>


                                        <div ref={fixedTitleRef} className={`flex items-center justify-between gap-1 w-full text-left p-3 pl-4 pb-2 md:p-4 -mt-10 sticky top-0 bg-white shadow-reverse-lg transition-all ease-in-out duration-300 ${fixedTitle ? 'rounded-t-none' : ' rounded-t-2xl'}`}>
                                            <TitleProduct product={product} className={`${product.type === PRODUCT_TYPE_COMPOSITE && 'mt-1'}`} />
                                            <ButtonLink rounded onClick={handleShare} className='self-start bg-transparent focus:bg-transparent'><div><TbShare size={20} /></div></ButtonLink>
                                        </div>

                                        {/* PRICE */}
                                        <div className='p-4 pt-0 font-medium text-left text-nowrap leading-none'>
                                            <ProductPrice product={product} breakLine={false} />
                                        </div>

                                        <div className='flex flex-col gap-4 text-left p-4 pt-0 md:mb-0'>
                                            {/* DESCRIPTION */}
                                            <p className='text-left leading-5 text-gray-500' dangerouslySetInnerHTML={{ __html: description }} />

                                            {/* TAGS */}
                                            <BoxContentTags product={product} />

                                            {/* OBSERVATION */}
                                            {((!isStoreCounter && product.type === PRODUCT_TYPE_SIMPLE) || (isStoreCounter && cartDisplay && product.type === PRODUCT_TYPE_SIMPLE)) &&
                                                <AddProductObservation onHandleObservation={(e: any) => handleObservation(e) } observation={currentProduct.observation} />
                                            }
                                        </div>

                                    </header>

                                    {product.type === PRODUCT_TYPE_COMPOSITE &&
                                        <div className={`flex flex-col gap-8 md:h-full`}>

                                            {loadingSteps
                                                ?
                                                    <div className="flex items-center justify-center gap-1 min-h-full text-gray-400 p-3 pt-8">
                                                        <ImSpinner8 className="animate-spin" />
                                                        <span>{t('add_product.steps.loading')}</span>
                                                    </div>
                                                :
                                                currentSteps.length === 0
                                                    ?   <div className='h-full flex items-center justify-center gap-1 text-gray-500'><TbMoodConfuzed /> <span>{t('add_product.steps.no_products_found')}</span></div>
                                                    :   currentSteps.map((step: any, index: number) => <SlotStep product={product} step={step} key={index} stepIndex={index} scrollToNextStepWithOffset={() => autoScrollSteps(index)} />)
                                            }

                                            <BoxContentEndScrollbars show={!loadingSteps && currentSteps.length > 0} message={t('products.end_of_list')} />

                                        </div>
                                    }

                                </section>
                            </div>

                        </div>

                    </div>
                </div>

            </Scrollbars>
        </div>



        <div className={`mt-2 w-full h-2 bg-white shadow-reverse-md transition
            ${showShadow ? 'opacity-100' : 'opacity-0'}
        `}></div>

        {/* Footer buttons */}
        <div className={`flex gap-2 w-full p-3 md:p-4 md:pt-2 z-40 bg-white md:justify-end text-sm ${!cashier && 'justify-end'}`}>

            {(isStoreCounter && cashier) &&
                <>
                    {!cartDisplay ?
                        <ButtonOpenStoreCounter
                            label={cartFinished
                                    ? <div className='flex items-center gap-1 w-full justify-between'><Badge type='success' outline className='h-5 ring-2 rounded-full font-extrabold text-sm'>{t('proof_payment.paid')}</Badge> {t('proof_payment.see_your_receipt_label')}</div>
                                    : undefined
                            } />
                        :
                        <>
                            <div className='hidden md:block w-2/5' />
                            {product.type === PRODUCT_TYPE_SIMPLE &&
                                <ButtonsIncDec disabled={loadingSteps} onInc={handleUpdateProduct} onDec={handleUpdateProduct} className='md:w-auto min-w-28' />
                            }
                            <ButtonAddProduct
                                currentProduct={currentProduct}
                                currentPrice={currentPrice}
                                disabledButtonAddProduct={disabledButtonAddProduct}
                                onHandleAdd={handleAdd}
                            />
                        </>
                    }
                </>
            }

            {!isStoreCounter &&
                <>
                    {product.type === PRODUCT_TYPE_SIMPLE &&
                        <ButtonsIncDec disabled={loadingSteps} onInc={handleUpdateProduct} onDec={handleUpdateProduct} className='md:w-auto min-w-28' />
                    }
                    <ButtonAddProduct
                        currentProduct={currentProduct}
                        currentPrice={currentPrice}
                        disabledButtonAddProduct={disabledButtonAddProduct}
                        onHandleAdd={handleAdd}
                    />
                </>
            }

            <Button rounded={((isStoreCounter && cashier) || !isStoreCounter)} className={`${isStoreCounter && !cashier && 'w-full'}`} onClick={handleCancel}>
                {((isStoreCounter && !cashier)) ? t('add_product.close_button_label') : <div><HiXMark size={20} /></div>}
            </Button>

        </div>

    </section>
  )
}

export default AddProduct;